import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { RegistrationEnquiries } from "@/components/admin/RegistrationEnquiries";

export const Route = createFileRoute("/admin/registrations")({
  component: RegistrationsPage,
  head: () => ({
    meta: [
      { title: "Registration Enquiries — Events UASA Admin" },
      {
        name: "description",
        content: "Review delegate registrations submitted from the public site.",
      },
    ],
  }),
});

function RegistrationsPage() {
  return (
    <AdminLayout>
      <RegistrationEnquiries />
    </AdminLayout>
  );
}
